import CurrencySettings from './CurrencySettings.component';

export default CurrencySettings;
